/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ thing: NonNullable<unknown> }} Equivalence_LiftedInputs */

const en_us2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You lifted ${i?.thing}.`)
};

const pt_br2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você levantou ${i?.thing}.`)
};

const es_419_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantaste ${i?.thing}.`)
};

const pt_pt2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantaste ${i?.thing}.`)
};

const fr_fr2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu as soulevé ${i?.thing}.`)
};

const de_de2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast ${i?.thing} bewegt.`)
};

const it_it2_equivalence_lifted = /** @type {(inputs: Equivalence_LiftedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai sollevato ${i?.thing}.`)
};

/**
* | output |
* | --- |
* | "You lifted {thing}." |
*
* @param {Equivalence_LiftedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_lifted = /** @type {((inputs: Equivalence_LiftedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_LiftedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_lifted(inputs)
	if (locale === "es-419") return es_419_equivalence_lifted(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_lifted(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_lifted(inputs)
	if (locale === "de-DE") return de_de2_equivalence_lifted(inputs)
	if (locale === "it-IT") return it_it2_equivalence_lifted(inputs)
	return en_us2_equivalence_lifted(inputs)
});
export { equivalence_lifted as "equivalence.lifted" }